<template>
  <div class="mt-3">
      <div v-if="explain !== 'Đang bổ sung giải thích cho câu trả lời.'" class="border rounded bg-light p-3" v-html="explain.replace('%link', `<a href='/goi-cuoc'>Nâng cấp tài khoản ngay !</a>`)"></div>
  </div>
</template>

<script>

export default {
  name: 'ExplainQuestion',
  props: {
    explain: String
  },
  data() {
    return {
        
    }
  },
  methods: {
      
  }
}
</script>